<template>
  <th class="tw-w-8"></th>
</template>

<script>
export default {
  name: 'ExpandableHead'
}
</script>
